export default {"src":"/_next/static/media/popular-icon.978d1bd3.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};